import { makeStyles } from "@material-ui/core";

export const useExpandContentStyles = makeStyles((theme) => ({
  expandContentRoot: {
    padding: 15,
    "& $tableContainer": {
      padding: "0 5px",
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: 360,
    },
    "& tr$tableHeaderRow": {
      height: 32,
    },
    "& $tableHeader": {
      background: theme.hv.palette.atmosphere.atmo2,
      borderTop: "none",
      paddingLeft: 10,
      paddingTop: 8,
      height: 32,
    },
    "& $tableCell": {
      paddingLeft: 10,
    },
  },
  tableContainer: {},
  tableHeaderRow: {},
  tableHeader: {},
  tableCell: {},
  stepDetailsName: {
    position: "absolute",
    top: 4,
    left: 0,
    lineHeight: "32px",
    width: "100%",
  },
  stepLocked: {
    "& > *": {
      color: theme.hv.palette.atmosphere.atmo5,
    },
  },
}));

const styles = makeStyles(() => ({
  stepsPartialTotal: {
    "&::first-letter": {
      fontWeight: 600,
    },
  },
}));

export default styles;
